import TCS34725		from "./circuits/tcs34725.js";

class ColorSensor {
	constructor() {
		this.id = "TCS34725";
		this.status = "uninitialized";
		this.value = "-";
		this.__tcs34725 = new TCS34725();
	}
	initialize() {
		return( new Promise(function(resolve, reject) {
			this.status = "Failed";
			this.__tcs34725.begin();
			this.status = "Ok";
		}.bind(this)) );
	}
	measure() {
		return( new Promise(function(resolve, reject) {
			try {
				this.value = this.__tcs34725.value;
				this.status = "Ok";
				resolve(this.value);
			} catch(e) {
				this.status = "Failed";
				this.value = "-";
				throw e;
			}
		}.bind(this)) );
	}
	toJSON() {
		return({
			id: this.id,
			status: this.status,
			value: this.value
		});
	}
}

export default ColorSensor;